export const PROFIT_REPORT_LIST_INITING = 'PROFIT_REPORT_LIST_INITING'
export const PROFIT_REPORT_LIST_REQUESTING = 'PROFIT_REPORT_LIST_REQUESTING'
export const PROFIT_REPORT_LIST_SUCCESS = 'PROFIT_REPORT_LIST_SUCCESS'
export const PROFIT_REPORT_LIST_ERROR = 'PROFIT_REPORT_LIST_ERROR'

export const PROFIT_REPORT_NVKD_REQUESTING = 'PROFIT_REPORT_NVKD_REQUESTING'
export const PROFIT_REPORT_NVKD_SUCCESS = 'PROFIT_REPORT_NVKD_SUCCESS'
export const PROFIT_REPORT_NVKD_ERROR = 'PROFIT_REPORT_NVKD_ERROR'

export const PROFIT_REPORT_KH_REQUESTING = 'PROFIT_REPORT_KH_REQUESTING'
export const PROFIT_REPORT_KH_SUCCESS = 'PROFIT_REPORT_KH_SUCCESS'
export const PROFIT_REPORT_KH_ERROR = 'PROFIT_REPORT_KH_ERROR'

export const PROFIT_REPORT_KHOXUAT_REQUESTING = 'PROFIT_REPORT_KHOXUAT_REQUESTING'
export const PROFIT_REPORT_KHOXUAT_SUCCESS = 'PROFIT_REPORT_KHOXUAT_SUCCESS'
export const PROFIT_REPORT_KHOXUAT_ERROR = 'PROFIT_REPORT_KHOXUAT_ERROR'

export const PROFIT_REPORT_EXPORT_XLS_REQUESTING = 'PROFIT_REPORT_EXPORT_XLS_REQUESTING'
export const PROFIT_REPORT_EXPORT_XLS_SUCCESS = 'PROFIT_REPORT_EXPORT_XLS_SUCCESS'
export const PROFIT_REPORT_EXPORT_XLS_ERROR = 'PROFIT_REPORT_EXPORT_XLS_ERROR'

export const PROFIT_REPORT_KH_BY_NHOM_REQUESTING = 'PROFIT_REPORT_KH_BY_NHOM_REQUESTING'
export const PROFIT_REPORT_KH_BY_NHOM_SUCCESS = 'PROFIT_REPORT_KH_BY_NHOM_SUCCESS'
export const PROFIT_REPORT_KH_BY_NHOM_ERROR = 'PROFIT_REPORT_KH_BY_NHOM_ERROR'

export const PROFIT_REPORT_NHOMKH_REQUESTING = 'PROFIT_REPORT_NHOMKH_REQUESTING'
export const PROFIT_REPORT_NHOMKH_SUCCESS = 'PROFIT_REPORT_NHOMKH_SUCCESS'
export const PROFIT_REPORT_NHOMKH_ERROR = 'PROFIT_REPORT_NHOMKH_ERROR'

export const PROFIT_REPORT_NVKD_API = '/api/v1/users/get_list_by_quanly'
export const PROFIT_REPORT_KH_API = '/api/v1/khachhang/KhachByNvkd'
export const PROFIT_REPORT_KHOXUAT_API = '/api/v1/kho/getKhoAllOfUser'
export const PROFIT_REPORT_LIST_API = '/api/v1/report/baoCaoLoiNhan'
export const PROFIT_REPORT_EXPORT_XLS_API = '/api/v1/report/baoCaoLoiNhan_export' 
export const PROFIT_REPORT_NHOMKH_API = '/api/v1/nhomkhachhang/nhomkhachhang_list_actived_by_store'
export const PROFIT_REPORT_KH_BY_NHOM_API = '/api/v1/khachhang/khachhangByNhomOrNvkd'


// WEBPACK FOOTER //
// ./src/views/Reports/ProfitReport/constants.js